import firebase from 'firebase'

firebase.initializeApp({
  apiKey: 'AIzaSyBqcXYVZQ72M8Hy4xjkVnbOFbSbcBybn4s',
  authDomain: 'amalinheritage-566f5.firebaseapp.com',
  databaseURL: 'https://amalinheritage-566f5.firebaseio.com',
  messagingSenderId: '202868802196',
  projectId: 'amalinheritage-566f5',
  storageBucket: 'amalinheritage-566f5.appspot.com',
})

export const auth = firebase.auth()
export const db = firebase.database()
export const storage = firebase.storage()



// WEBPACK FOOTER //
// ./src/data/firebase.js